'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVideocamOff = function AvVideocamOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z' })
  );
};
AvVideocamOff = (0, _pure2.default)(AvVideocamOff);
AvVideocamOff.displayName = 'AvVideocamOff';

exports.default = AvVideocamOff;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/videocam-off.js
 ** module id = 1241
 ** module chunks = 0
 **/